<!-- ConnectionStatusAlert.vue -->
<template>
	<div v-if="connectionState !== 'Connected'" class="orange lighten-5 pa-4">
		<v-alert
			v-if="connectionState === 'Connecting'"
			color="info"
			dark
		>
			<div class="poppins-medium">Connessione in corso...</div>
			<v-progress-linear
				indeterminate
				class="mt-2"
				color="white"
			></v-progress-linear>
		</v-alert>

		<!-- Reconnecting state with progress indicator -->
		<v-alert
			v-else-if="connectionState === 'Reconnecting'"
			color="info"
			dark
		>
			<div class="poppins-medium">Riconnessione in corso...</div>
			<v-progress-linear
				indeterminate
				class="mt-2"
				color="white"
			></v-progress-linear>
		</v-alert>

		<!-- Disconnecting state -->
		<v-alert
			v-else-if="connectionState === 'Disconnecting'"
			color="warning"
			dark
		>
			<div class="poppins-medium">Disconnessione in corso...</div>
			<v-progress-linear
				indeterminate
				class="mt-2"
				color="white"
			></v-progress-linear>
		</v-alert>

		<!-- Disconnected state -->
		<v-alert
			v-else-if="connectionState === 'Disconnected'"
			color="error"
			dark
			icon="fas fa-times"
		>
			<div class="poppins-medium">
				Connessione al server persa. Per favore, aggiorna la
				pagina
			</div>
		</v-alert>

		<!-- Fallback for any other state -->
		<v-alert v-else color="error">
			<div class="poppins-medium">
				Connessione al server persa. Per favore, aggiorna la
				pagina.
			</div>
		</v-alert>
	</div>
</template>

<script>
export default {
	name: "ConnectionStatusAlert",
	props: {
		connectionState: {
			type: String,
			required: true
		}
	}
}
</script>
